import { Box } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { CommentFooter } from './components/CommentFooter';
import { usePageBody } from './hooks/usePageBody';

export function PageBody() {
	const {
		data: { comment },
	} = usePageBody();

	return (
		<Box>
			<Box
				variant="bordered"
				p={8}
				mb={16}
				sx={{
					position: 'relative',
					'&:before': {
						content: '""',
						position: 'absolute',
						bottom: -9,
						left: 10,
						borderWidth: '9px 7px 0',
						borderStyle: 'solid',
						borderLeftColor: 'transparent',
						borderRightColor: 'transparent',
						borderTopColor: 'neutral-grey400',
						borderBottomColor: 'neutral-grey400',
					},
					'&:after': {
						content: '""',
						position: 'absolute',
						left: 10,
						bottom: -7,
						borderWidth: '9px 7px 0',
						borderStyle: 'solid',
						borderLeftColor: 'transparent',
						borderRightColor: 'transparent',
						borderTopColor: 'primary-white',
						borderBottomColor: 'primary-white',
					},
				}}
			>
				<Text as="div" size={['default', 'large']} breakWord sx={{ whiteSpace: 'pre-wrap' }} data-qa="comment-body">
					{comment}
				</Text>
			</Box>
			<CommentFooter />
		</Box>
	);
}
